import React from 'react';
import { t, jt } from 'ttag';

import Social from 'js/reusable-components/Social';

import 'js/giftcard/components/socialText.scss';

const instaChannelName = {
  'de-AT': '@unisportstorede',
  'de': '@unisportstorede',
  'nl': '@unisport.nl',
  'fr': '@unisportstorefr',
  'en': '@unisportstore',
  'fi': '@unisportstorefi',
  'nb': '@unisportstoreno',
  'sv': '@unisportstorese',
  'da': '@unisport'
};
const instalHashTag = '#unisportlife';
const instaComp = (
  <b key="icn">{instaChannelName[window?.config?.language_code || 'en']}</b>
);
const hashtagComp = <b key="ht">{instalHashTag}</b>;
const breakline = <br key="br" />;

function SocialText() {
  return (
    <div className="innerWidth">
      <div className="social-component">
        <div className="social-textholder">
          <h2 className="social-title title">{t`Stay updated with Unisport`}</h2>
          <div className="social-text text">
            {jt`Add ${instaComp} ${breakline} and use ${hashtagComp} to share your pictures with us.`}
          </div>
        </div>

        <Social
          iconsToShow={[
            'YouTube',
            'Instagram',
            'Facebook',
            'TikTok',
            'SnapChat'
          ]}
        />
      </div>
    </div>
  );
}

export default SocialText;
